var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlgopadRocketImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 94,
    viewBox: "0 0 82 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1532 3.06748C40.2031 2.47295 41.0671 2.47295 41.117 3.06748L45.6308 56.8366C45.7389 58.1244 46.0725 59.3828 46.6161 60.5536L61.7138 93.0693C61.9651 93.6104 61.2144 94.0437 60.8776 93.5519L44.6164 69.8051C42.6943 66.9981 38.5759 66.9981 36.6538 69.8051L20.3926 93.5519C20.0558 94.0437 19.3051 93.6104 19.5564 93.0693L34.6541 60.5536C35.1977 59.3828 35.5313 58.1244 35.6394 56.8365L40.1532 3.06748Z",
    fill: "url(#paint0_linear_418_5331)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.646 57.804L36.5491 45.3455C36.5647 45.1291 36.8655 45.089 36.9373 45.2938L45.891 70.8497C45.9666 71.0653 45.6798 71.2187 45.5425 71.0361L35.6857 57.9387C35.6566 57.9001 35.6426 57.8522 35.646 57.804Z",
    fill: "#282A32"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.84181,
    height: 0.976762,
    transform: "matrix(-0.705452 0.708757 -0.705452 -0.708757 7.86328 83.6938)",
    fill: "url(#paint1_linear_418_5331)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.84181,
    height: 0.976762,
    transform: "matrix(0.705452 0.708757 0.705452 -0.708757 74.4414 83.6938)",
    fill: "url(#paint2_linear_418_5331)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.65026,
    height: 0.976762,
    transform: "matrix(0.705452 -0.708757 -0.705452 -0.708757 2.47266 89.1094)",
    fill: "url(#paint3_linear_418_5331)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 0.409172,
    height: 0.975702,
    transform: "matrix(0.705452 -0.708757 -0.705452 -0.708757 1.2168 90.3711)",
    fill: "url(#paint4_linear_418_5331)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.65026,
    height: 0.976762,
    transform: "matrix(-0.705452 -0.708757 0.705452 -0.708757 79.832 89.1094)",
    fill: "url(#paint5_linear_418_5331)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 0.241174,
    height: 0.975702,
    transform: "matrix(-0.705452 -0.708757 0.705452 -0.708757 80.8418 90.1216)",
    fill: "url(#paint6_linear_418_5331)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3016 81.1644L56.6658 65.4553C53.481 62.2556 51.4121 58.1147 50.7659 53.6466L44.4863 10.2256",
    stroke: "url(#paint7_linear_418_5331)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39762 81.1644L25.0334 65.4553C28.2182 62.2556 30.2871 58.1147 30.9333 53.6466L37.2129 10.2256",
    stroke: "url(#paint8_linear_418_5331)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.7973 39.8909L31.2207 20.5439",
    stroke: "url(#paint9_linear_418_5331)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M56.4699 54.9385L53.9023 39.4609",
    stroke: "url(#paint10_linear_418_5331)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M51.3324 28.7127L50.4766 22.6936",
    stroke: "url(#paint11_linear_418_5331)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M35.073 3.34668L35.5 0.76709",
    stroke: "url(#paint12_linear_418_5331)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_418_5331",
    x1: 72.7472,
    y1: 129.048,
    x2: 6.17882,
    y2: 33.4305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC5C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_418_5331",
    x1: 1.42091,
    y1: 0,
    x2: 1.42091,
    y2: 0.976762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_418_5331",
    x1: 1.42091,
    y1: 0,
    x2: 1.42091,
    y2: 0.976762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_418_5331",
    x1: 0.825129,
    y1: 0,
    x2: 0.825129,
    y2: 0.976762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_418_5331",
    x1: 0.204586,
    y1: 0,
    x2: 0.204586,
    y2: 0.975702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_418_5331",
    x1: 0.825129,
    y1: 0,
    x2: 0.825129,
    y2: 0.976762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_418_5331",
    x1: 0.120587,
    y1: 0,
    x2: 0.120587,
    y2: 0.975702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_418_5331",
    x1: 62.6732,
    y1: 10.2256,
    x2: 62.6732,
    y2: 81.1644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_418_5331",
    x1: 25.6589,
    y1: 11.9453,
    x2: 18.9643,
    y2: 81.1584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_418_5331",
    x1: 21.3784,
    y1: 11.9453,
    x2: 14.6838,
    y2: 81.1584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_418_5331",
    x1: 62.8888,
    y1: 26.9929,
    x2: 69.5834,
    y2: 96.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_418_5331",
    x1: 59.463,
    y1: 8.93578,
    x2: 66.1576,
    y2: 78.1489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_418_5331",
    x1: 27.814,
    y1: -17.29,
    x2: 21.1052,
    y2: 51.9202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgopadRocketImg);
export default __webpack_public_path__ + "static/media/algopad-rocket-img.5015e8bd0b42526d8cd8e94ad8dcae4a.svg";
export { ForwardRef as ReactComponent };